import { type IconNames } from '@petsmart-ui/sparky';

export enum VetRxCats {
    COLD = 'Cold Items',
    RX = 'Pharmacy',
    VET = 'Veterinary Diets',
}

export type VetRxInfo = { text: string; icon: IconNames };
